import { render, staticRenderFns } from "./CustomerContractDetailsPricelist.vue?vue&type=template&id=fb461a2e&scoped=true&"
import script from "./CustomerContractDetailsPricelist.vue?vue&type=script&lang=js&"
export * from "./CustomerContractDetailsPricelist.vue?vue&type=script&lang=js&"
import style0 from "./CustomerContractDetailsPricelist.vue?vue&type=style&index=0&id=fb461a2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb461a2e",
  null
  
)

export default component.exports